import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../components/BreadCrumb";
import { FAQ_DATA } from "../../utils/internalPageData";
import { pushToDataLayer } from "../../utils/gtm";

const FAQ = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [activeQuestion, setActiveQuestion] = useState(null);

  const filteredFAQs = useMemo(
    () =>
      FAQ_DATA.filter(({ question, answer }) =>
        [question, answer].some((text) =>
          text.toLowerCase().includes(searchTerm.toLowerCase())
        )
      ),
    [searchTerm]
  );

  return (
    <div className="max-w-5xl mx-auto p-6">
      <BreadCrumb
        title="Frequently Asked Questions"
        desc="Get clear and reliable information to help you make informed decisions."
      />
      <div className="mb-8 relative">
        <input
          type="text"
          placeholder="Search FAQ..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all duration-200"
        />
        <div className="absolute right-3 top-3 text-gray-400">🔍</div>
      </div>

      <div className="space-y-4">
        {filteredFAQs.length > 0 ? (
          filteredFAQs.map(({ id, question, answer, bulletPoints }) => (
            <div
              key={id}
              className="border rounded-lg bg-white shadow-sm hover:shadow-md transition-shadow duration-200"
            >
              <button
                onClick={() =>
                  setActiveQuestion(activeQuestion === id ? null : id)
                }
                className="w-full px-6 py-4 flex justify-between items-center text-left hover:bg-gray-50"
              >
                <span className="font-semibold text-gray-800">{question}</span>
                <span className="text-[#7B3BCC] transition-transform duration-200">
                  {activeQuestion === id ? "−" : "+"}
                </span>
              </button>
              {activeQuestion === id && (
                <div className="px-6 py-4 bg-gray-50">
                  <p className="text-gray-700">{answer}</p>
                  {bulletPoints?.length > 0 && (
                    <ul className="list-disc ml-6 mt-2 space-y-1">
                      {bulletPoints.map((point, index) => (
                        <li key={index} className="text-gray-700">
                          {point}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="text-center py-8">
            <p className="text-gray-500">
              No matching questions found. Try a different search term.
            </p>
          </div>
        )}
      </div>

      <div className="mt-12 p-6 bg-[#f3eaff] rounded-lg text-center">
        <h3 className="text-xl font-semibold mb-2">Still have questions?</h3>
        <p className="text-gray-600 mb-4">
          Our support team is here to help you 24/7
        </p>
        <button
          className="px-6 py-3 bg-[#7b3BCC] text-white rounded-lg font-[500] transition-colors duration-200 hover:bg-[#6a30b5]"
          onClick={() => {
            pushToDataLayer("cta_clicked", { cta_name: "Contact Support" });
            navigate("/contact");
          }}
        >
          Contact Support
        </button>
      </div>
    </div>
  );
};

export default FAQ;
